import { render, staticRenderFns } from "./AppIdForm.vue?vue&type=template&id=10f948bc&"
import script from "./AppIdForm.vue?vue&type=script&lang=js&"
export * from "./AppIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports